export const DESKTOP_BRIDGE_AUTH_TOKEN_KEY = 'zeettu.printBridge.authToken';
export const DESKTOP_BRIDGE_HTTP_BASE =
  (import.meta.env.VITE_ZEETTU_PRINT_BRIDGE_HTTP_BASE as string | undefined)?.trim() ||
  'http://127.0.0.1:38481';
export const DESKTOP_BRIDGE_WS_BASE =
  (import.meta.env.VITE_ZEETTU_PRINT_BRIDGE_WS_BASE as string | undefined)?.trim() ||
  'ws://127.0.0.1:38482';
export const DESKTOP_BRIDGE_DOWNLOAD_URL =
  (import.meta.env.VITE_ZEETTU_PRINT_BRIDGE_DOWNLOAD_URL as string | undefined)?.trim() ||
  '/downloads/zeettu-print-bridge.exe';
export const DESKTOP_BRIDGE_EXPECTED_API_VERSION = 1;
export const DESKTOP_BRIDGE_REQUEST_TIMEOUT_MS = 6_000;
export const DESKTOP_BRIDGE_PROBE_TIMEOUT_MS = 2_500;
/** A full LAN /24 sweep takes a few seconds. */
export const DESKTOP_BRIDGE_SCAN_TIMEOUT_MS = 30_000;
export const DESKTOP_BRIDGE_JOB_TIMEOUT_MS = 25_000;
/** Re-probe interval while the bridge is not running (it may be started later). */
export const DESKTOP_BRIDGE_RETRY_MS = 20_000;
